<div class="responsive-container p-grid">
  <p-toast></p-toast>
  <p-panel>
    <ng-template pTemplate="header">
      <div class="responsive-header">
        <span class="responsive-header-title">{{ title }}</span>
        <button pButton icon="pi pi-times" class="p-button-rounded p-button-text" (click)="onDialogClose()"></button>
      </div>
    </ng-template>

    <div class="content">
      <p-fluid>
        <div class="field">
          <label for="warehouse">Bodega <span class="req">*</span> </label>
          <p-select [options]="warehouses" [(ngModel)]="selectedWarehouse" optionLabel="name"
            placeholder="Selecciona un Almacén" appendTo="body">
          </p-select>
        </div>
        <div class="field">
          <label for="account">Cuenta <span class="req">*</span> </label>
          <p-select [options]="accounts" [(ngModel)]="selectedAccount" (onChange)="onAccountSelect()" optionLabel="name"
            [resetFilterOnHide]="true" [filter]="true" lazy="true" (onFilter)="loadAccounts($event)"
            placeholder="Selecciona una Cuenta" [panelStyle]="{maxWidth: '90vw', overflowX: 'auto'}">
            <ng-template let-item pTemplate="item">
              <div style="white-space: normal; word-break: break-word;">
                {{ item.name }}
              </div>
            </ng-template>
            <ng-template pTemplate="empty">
              <div class="p-text-center p-p-2">
                No se encontraron cuentas
              </div>
            </ng-template>
          </p-select>
        </div>
        @if (type === constArticlesRelease) {
        <div class="field">
          <label for="itemGroups">Grupo de Salida</label>
          <p-select [options]="itemGroups" [(ngModel)]="selectedItemGroup" optionLabel="name" [resetFilterOnHide]="true"
            [showClear]="true" placeholder="Selecciona un Grupo de Salida"
            [panelStyle]="{maxWidth: '90vw', overflowX: 'auto'}">
            <ng-template let-item pTemplate="item">
              <div class="custom-item-group">
                <div class="left">
                  <div class="group-name">{{ item.itemGroupId }} - {{ item.name }}</div>
                  <div class="group-date">Salida: {{ item.exitDate | date: 'medium' }}</div>
                  <div class="group-count">
                    <span class="label">Artículos:</span>
                    <span class="value">{{ item.articleCount }}</span>
                  </div>
                </div>
                <div class="right">
                  <button type="button" class="delete-btn" (click)="deleteItemGroup($event, item)"
                    title="Eliminar grupo">
                    <i class="pi pi-trash"></i>
                  </button>
                </div>
              </div>
            </ng-template>
            <ng-template pTemplate="empty">
              <div class="p-text-center p-p-2">
                No se encontraron grupos de salida
              </div>
            </ng-template>
            <ng-template let-item pTemplate="selectedItem">
              @if (item) {
              <div class="custom-selected ellipsis-text" title="{{ item.name }}">
                {{ item.name }}
              </div>
              }
            </ng-template>
          </p-select>
        </div>
        }
        <div class="p-field flex justify-content-between">
          <p-button label="Cancelar" severity="secondary" (click)="onDialogClose()"></p-button>
          <p-button label="Aceptar " [disabled]="!selectedWarehouse || !selectedAccount"
            (click)="onAccept()"></p-button>
        </div>
      </p-fluid>
    </div>
  </p-panel>
</div>
<p-confirmDialog [style]="{ width: 'clamp(320px, 90vw, 450px)' }"></p-confirmDialog>